import { HiOutlineArrowRight } from "react-icons/hi";
import { IS_BETA_HOST } from "../utils";

const BetaBanner = () => {
  if (!IS_BETA_HOST) return null;

  const productionUrl = `https://admin.querco.co${window.location.pathname}${window.location.search}`;

  return (
    <div className="flex h-8 items-center justify-between gap-3 border-t border-gray-200 bg-gray-50 px-4 text-xs text-gray-700">
      <span className="truncate">
        <span className="font-medium">Vous êtes sur la version bêta.</span> Cette version peut contenir des fonctionnalités en cours de test.
      </span>
      <a
        href={productionUrl}
        className="flex shrink-0 items-center gap-1 rounded-md border border-gray-300 bg-white px-2 py-0.5 font-medium text-gray-700 transition-colors hover:bg-gray-100"
      >
        Aller sur admin.querco.co
        <HiOutlineArrowRight className="h-3 w-3" />
      </a>
    </div>
  );
};

export default BetaBanner;
